import { useQuery } from '@tanstack/react-query';
import { getAnswersByType } from '../services/AnswersByTypeService';
import { answersByTypeKeys } from './queryKeys';
export function useAnswersByType(inspectionId) {
    return useQuery({
        queryKey: answersByTypeKeys.inspection(inspectionId),
        queryFn: () => getAnswersByType(inspectionId),
        enabled: !!inspectionId,
        staleTime: 30000
    });
}
